/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleDistributionPeriodResponse
 */
export interface DutyScheduleDistributionPeriodResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    periodEnd: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    isCurrent: boolean;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    totalWeeklyHours: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    aw12Total: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    aw3Total: number;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleDistributionPeriodResponse
     */
    bgsTotal: number;
}

/**
 * Check if a given object implements the DutyScheduleDistributionPeriodResponse interface.
 */
export function instanceOfDutyScheduleDistributionPeriodResponse(value: object): value is DutyScheduleDistributionPeriodResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('isCurrent' in value) || value['isCurrent'] === undefined) return false;
    if (!('totalWeeklyHours' in value) || value['totalWeeklyHours'] === undefined) return false;
    if (!('aw12Total' in value) || value['aw12Total'] === undefined) return false;
    if (!('aw3Total' in value) || value['aw3Total'] === undefined) return false;
    if (!('bgsTotal' in value) || value['bgsTotal'] === undefined) return false;
    return true;
}

export function DutyScheduleDistributionPeriodResponseFromJSON(json: any): DutyScheduleDistributionPeriodResponse {
    return DutyScheduleDistributionPeriodResponseFromJSONTyped(json, false);
}

export function DutyScheduleDistributionPeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDistributionPeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'isCurrent': json['isCurrent'],
        'totalWeeklyHours': json['totalWeeklyHours'],
        'aw12Total': json['aw12Total'],
        'aw3Total': json['aw3Total'],
        'bgsTotal': json['bgsTotal'],
    };
}

export function DutyScheduleDistributionPeriodResponseToJSON(json: any): DutyScheduleDistributionPeriodResponse {
    return DutyScheduleDistributionPeriodResponseToJSONTyped(json, false);
}

export function DutyScheduleDistributionPeriodResponseToJSONTyped(value?: DutyScheduleDistributionPeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'periodStart': `${value['periodStart'].getFullYear()}-${String(value['periodStart'].getMonth()+1).padStart(2,'0')}-${String(value['periodStart'].getDate()).padStart(2,'0')}`,
        'periodEnd': `${value['periodEnd'].getFullYear()}-${String(value['periodEnd'].getMonth()+1).padStart(2,'0')}-${String(value['periodEnd'].getDate()).padStart(2,'0')}`,
        'isCurrent': value['isCurrent'],
        'totalWeeklyHours': value['totalWeeklyHours'],
        'aw12Total': value['aw12Total'],
        'aw3Total': value['aw3Total'],
        'bgsTotal': value['bgsTotal'],
    };
}

